import React from "react";
import SiteShell from "@/components/site/SiteShell";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
    return (
        <SiteShell>
            <section className="pt-40 pb-24 px-4 text-center">
                <span className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">Error 404</span>
                <h1 className="font-heading text-5xl font-semibold mt-3">Page not found</h1>
                <p className="mt-3 text-muted-foreground">The page you're looking for doesn't exist or has been moved.</p>
                <Link to="/" className="inline-block mt-6">
                    <Button variant="outline" className="rounded-full">Go home</Button>
                </Link>
            </section>
        </SiteShell>
    );
}
